module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-VC-Australia-Website.51a5f40c.jpg";